export const screenSize = {
	data() {
		return {
			widthScreenWindow: window.innerWidth,
			heightScreenWindow: window.innerHeight,
		}
	},
	beforeMount() {
		window.addEventListener('resize', this.onSizeChange)
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.onSizeChange)
	},
	methods: {
		onSizeChange() {
			this.widthScreenWindow = window.innerWidth;
			this.heightScreenWindow = window.innerHeight;
			EventBus.$emit('change_size_screen');
		},
		screenPositionById(idElement){
			let element = document.getElementById(idElement);
			if(element !== null) {
				let rect = element.getBoundingClientRect();
				return {
					coordinateX: rect.left,
					coordinateY: rect.top
				}
			}
			return {
				coordinateX: 0,
				coordinateY: 0
			}
		}
	},
	computed: {
		screenParameters() {
			let isMobileScreen = this.widthScreenWindow < 768;
			//let isMobileScreen = this.widthScreenWindow <=1200;
			let typeScreen = '';
			if (this.widthScreenWindow < 479) typeScreen = 'xs'
			if (this.widthScreenWindow >= 479 && this.widthScreenWindow < 1200) typeScreen = 'md'
			else typeScreen='lg'

			return {
				isMobileBrowser: /Mobi/.test(navigator.userAgent),
				isMobileScreen: isMobileScreen,
				type: typeScreen,
				width: this.widthScreenWindow,
				height: this.heightScreenWindow,
			}
		},
        isMobileScreen() {
            if(this.widthScreenWindow<768){
                return true;
            }
            return false;
        }
	}
}
